import { LocalStorageKey } from "vendor/local"

export const clearMfa = () => {
  localStorage.removeItem(LocalStorageKey.MfaToken)
  localStorage.removeItem(LocalStorageKey.MfaTokenExp)
  localStorage.removeItem(LocalStorageKey.MfaRedirect)
}